// @owners { team: patients-team }
import { getPlatformOS } from '~shared/helpers/getPlatformOS';

const STAGING_HOSTS = ['app.stg.alto.com', 'stg.pharmacy.fuzehealth.com'];

type IsWebStagingParams = {
  backendEnv: string;
};

export const isWebStaging = ({ backendEnv }: IsWebStagingParams): boolean => {
  if (getPlatformOS() !== 'web' || backendEnv !== 'sandbox') {
    return false;
  }

  try {
    const origin = window.location?.origin ?? '';
    return STAGING_HOSTS.some((host) => origin.includes(host));
  } catch {
    return false;
  }
};
